import { useState, useEffect } from 'react';
import { API_CONFIG } from '../../config';


export const UseCoupon = () => {
    const [allCoupon, setAllCoupon] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const fetchUsers = async () => {
        try {
            setLoading(true);
            setError(null);
           
            const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.GETCOUPON}`);
            
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            
            const data = await response.json();
            
            // 🚨 THE CRITICAL FIX IS HERE:
            if (data.success && Array.isArray(data.coupon)) {
                // Set the 'users' state to the array found inside data.users
                setAllCoupon(data.coupon); 
            } else {
                // Handle cases where API returns success:true but 'users' is missing/not array
                throw new Error(data.message || 'API response structure is invalid.');
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setError(error.message);
            // Ensure state is set back to an empty array on error
            setAllCoupon([]); 
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return {
       allCoupon,
        loading,
        error,
        refetch: fetchUsers
    };
};

export default UseCoupon;